// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"177":"12582137","359":"12582137","827":"12582137"}[chunkId] + ".chunk.css";
};